// Copyright (c) StrangeBee 2023

import { QuerySelector } from 'thehive-sdk';

export const computeListSelector = (): QuerySelector => ({
    head: [{ name: 'listOrganisation' }],
    name: 'get-all-organisations',
    sort: ['+locked', '+name'],
});

interface GetSelectorParams {
    orgId: string;
}

export const computeGetSelector = ({ orgId }: GetSelectorParams): QuerySelector => ({
    head: [{ name: 'getOrganisation', idOrName: orgId }],
    name: `get-organisation-${orgId}`,
});
